import type {getConfiguration, showError, IErrorMessage, IApiConfig} from '@rlx/feim';
import * as RELAX_ERRORS from '@gongxigames/framework/integrations/relax/RelaxErrorMessages';
import {CustomErrorData, RubyPlayErrorsHandler, GameServerError} from '@gongxigames/framework/integrations/rubyplay/RubyPlayErrorsHandler';
import {consoleLogger, IEventManager} from '@gongxigames/framework/core';

export const RELAX_ERRORS_BY_ERROR_CODE: Record<string, IErrorMessage> = {
    'GS-2': RELAX_ERRORS.PLAYER_BLOCKED,
    'GS-3': RELAX_ERRORS.SESSION_EXPIRED,
    'GS-4': RELAX_ERRORS.GAME_DISABLED,
    'GS-5': RELAX_ERRORS.INSUFFICIENT_FUNDS,
    'GS-7': RELAX_ERRORS.SESSION_EXPIRED,
    'GS-97': RELAX_ERRORS.CUSTOM_ERROR,
    'M-1': RELAX_ERRORS.GAME_DISABLED,
    'M-5': RELAX_ERRORS.GAME_DISABLED
};
export const RELAX_CUSTOM_ERROR_CODE = 'GS-97';

export class RelaxErrorsHandler extends RubyPlayErrorsHandler {

    readonly getConfiguration: typeof getConfiguration;
    readonly showError: typeof showError;

    constructor(eventManager: IEventManager) {
        super(eventManager);

        const {
            getConfiguration: _getConfiguration,
            showError: _showError
        } = require('@gongxigames/framework/integrations/relax/RelaxEventsHandler');

        this.getConfiguration = _getConfiguration;
        this.showError = _showError;
    }

    public handleGameServerError(error: GameServerError): void {
        this._gameServerError = error;

        try {
            const configuration: IApiConfig = this.getConfiguration();

            // for now this supports only by Paddy Power Betfair, with who we do not integrate
            if (configuration.operatorHandlesErrors) {
                this.handleServerErrorByRelax();
            } else {
                this.sendMessageError(this.getMessageError());
            }

        } catch {
            this.sendMessageError(this.getMessageError());
        }

        consoleLogger.error(error);
    }

    protected handleServerErrorByRelax(): void {
        const {code, message} = this._gameServerError!.data;
        let relaxError = RELAX_ERRORS_BY_ERROR_CODE[code];

        if (relaxError) {
            if (code === RELAX_CUSTOM_ERROR_CODE) {
                relaxError = JSON.parse(message).errorParameters;
            }

            this.showError(relaxError);
        } else {
            // TODO: check case when we get not mapped error
        }
    }

    protected getCustomErrorData(data: any): CustomErrorData {
        const errorParameters: IErrorMessage = data.errorParameters;
        const {message = '', title = '', buttontext} = errorParameters.errorDetails!;

        const buttons = buttontext ? [buttontext] : [];

        return {message, title, buttons};
    }
}
